import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './v1/store/index'
import Buefy from 'buefy'
import 'buefy/lib/buefy.css'

// export const API_URL = 'http://ultrashop.uz:8000/api';
export const API_URL = process.env.VUE_APP_API_URL;
export const MEDIA_URL = process.env.VUE_APP_MEDIA_URL;

Vue.config.productionTip = true;
Vue.use(Buefy, {
    defaultIconPack: "far"
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
